module.exports = __webpack_public_path__ + "static/media/eye.be57edbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/eye.svg
// module id = 52
// module chunks = 1